import { render, staticRenderFns } from "./CrFooter.vue?vue&type=template&id=31280186&scoped=true"
import script from "./CrFooter.vue?vue&type=script&lang=js"
export * from "./CrFooter.vue?vue&type=script&lang=js"
import style0 from "./CrFooter.vue?vue&type=style&index=0&id=31280186&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31280186",
  null
  
)

export default component.exports